module.exports = __webpack_public_path__ + "img/1.14eb56b9.png";